// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1TT6c","right":"styles_right__2GLyX"};